import axios from "axios";
import RestService from "./rest.service";

const API_URL = process.env.REACT_APP_API_URL;

class AuthService {
  login(username, password, direct = false) {
    const oData = {
      username: username,
      password: password,
      direct: direct,
    };

    return new Promise((fnResolve, fnReject) => {
      RestService.post("app/login", oData).then(
        (response) => {
          fnResolve(response);
        },
        (err) => {
          fnReject(err);
        }
      );
    });
  }

  loginUser(username) {
    const oData = {
      username: username
    };
    return new Promise((fnResolve, fnReject) => {
      RestService.post("app/loginUser", oData).then(
        (response) => {
          fnResolve(response);
        },
        (err) => {
          fnReject(err);
        }
      );
    });
  }
  // login = (username, password) => (dispatch) => {
  //   {
  //     const oData = {
  //       username: 'test1@ipop-pms.com',
  //       password: '12345',
  //     }
  //     return RestService.get('site/nida').then(
  //         (response) => {
  //
  //           // set auth local storage
  //           localStorage.setItem("user", JSON.stringify(response.data.token));
  //           // mapping data
  //           dispatch({
  //             type: "SET_START_PARAM",
  //             payload: response.data,
  //           });
  //           return Promise.resolve(response.data);
  //         },
  //         (error) => {
  //           const message =
  //               (error.response &&
  //                   error.response.data &&
  //                   error.response.data.message) ||
  //               error.message ||
  //               error.toString();
  //           dispatch({
  //             type: "REGISTER_FAIL",
  //           });
  //           dispatch({
  //             type: "SET_MESSAGE",
  //             payload: message,
  //           });
  //           return Promise.reject();
  //         }
  //     );
  //   }
  //
  //   // return axios
  //   //     .post(API_URL + "signin", oData)
  //   //     .then((response) => {
  //   //       if (response.data.accessToken) {
  //   //         localStorage.setItem("user", JSON.stringify(response.data));
  //   //       }
  //   //
  //   //       return response.data;
  //   //     });
  // }
  logout() {
    return new Promise((fnResolve, fnReject) => {
      const site = localStorage.getItem("site")

      RestService.get(`app/logout`).then(
        (response) => {

          localStorage.removeItem("user");
          localStorage.removeItem("proxy");

          localStorage.clear();

          localStorage.setItem("site", site)

          fnResolve(response);
        },
        (response) => {
          localStorage.clear();
          localStorage.setItem("site", site)

          fnResolve(response);
        }
      );
    });
  }
  register(username, email, password) {
    return axios.post(API_URL + "signup", {
      username,
      email,
      password,
    });
  }

  forgetPassword(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.postsReset(`app/forgetPassword`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  changePassword(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.postsReset(`app/profile/changePassword`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  resetPassword(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.postsReset(`app/resetPassword`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  setPassword(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.postsReset(`app/newPassword`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
}

export default new AuthService();
